import { capitalizeWords } from '@zoocasa/node-kit/strings/capitalize';

type TextTransform = 'deDasherize' | 'dasherize' | 'deCamelize' | 'capitalize';

export default function textTransform(text: string, ...transforms: TextTransform[]) {
  transforms.forEach(transform => {
    if (transform === 'deDasherize') {
      text = text.replace(/-/g, ' ');
    } else if (transform === 'dasherize') {
      text = text.replace(/[.\s]/g, '-');
    } else if (transform === 'deCamelize') {
      text = text.replace(/([A-Z])/g, ' $1');
    } else if (transform === 'capitalize') {
      text = capitalizeWords(text);
    }
  });
  return text;
}
